import React from 'react';
import PropTypes from 'prop-types';
import Switch from './ui/Switch';

class LiveEventModalDetails extends React.Component{

    render() {
        return (
            <div className="tab-panel">
                <div className="column column-wide">
                    <label htmlFor="eventTitle">Title</label>
                    <input id="eventTitle" defaultValue={this.props.event.title} onChange={e => this.props.updateEvent("title", e.target.value)} placeholder="Enter title" />
                    <Switch checked={this.props.event.requireUsername === "true"} label="Require username to view" onChange={checked => this.props.updateEvent("requireUsername", checked) } />
                </div>
            </div>
        );
    }
}

LiveEventModalDetails.propTypes = {
    event: PropTypes.object.isRequired,
    updateEvent: PropTypes.func.isRequired
}

export default LiveEventModalDetails;


/** WEBPACK FOOTER **
 ** ./src/components/LiveEventModalDetails.js
 **/